import React, { useEffect, useState } from "react";
import AnnotationOverlay from "./AnnotationOverlay";
import { fetchAsBlobUrl } from "@/lib/uploads";

/**
 * Image renderer with a bounding-box annotation overlay.
 */
export default function ImageAnnotator({ fileId, annotations = [], canDraw, onCreate, onResolve }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    let live = true;
    let objUrl = null;
    setUrl(null); setErr("");
    (async () => {
      try {
        objUrl = await fetchAsBlobUrl(fileId);
        if (live) setUrl(objUrl);
      } catch (e) {
        if (live) setErr("Failed to load image");
      }
    })();
    return () => {
      live = false;
      if (objUrl) URL.revokeObjectURL(objUrl);
    };
  }, [fileId]);

  return (
    <div className="w-full flex-1 overflow-auto p-4 flex justify-center bg-[#050505]" data-testid="image-annotator">
      {err && <p className="text-sm text-red-400 py-10">{err}</p>}
      {!err && !url && <p className="text-xs font-mono text-gray-600 py-10">Loading…</p>}
      {url && (
        <div className="relative inline-block" style={{ maxWidth: "100%" }}>
          <img
            src={url}
            alt="drawing"
            style={{ maxWidth: "min(1100px, 100%)", maxHeight: "80vh", display: "block" }}
            draggable={false}
          />
          <AnnotationOverlay
            annotations={annotations}
            canDraw={canDraw}
            onCreate={(rect) => onCreate?.({ ...rect, page: null })}
            onResolve={onResolve}
          />
        </div>
      )}
    </div>
  );
}
